import {
  QualityEventAnswers,
  QualityEventField,
  qualityEventRows,
} from "src/types/quality-events";

export const linkedQualityEventRows = (
  field: Extract<QualityEventField, { type: "repeatable" }>,
  value: unknown,
  sourceAnswers: QualityEventAnswers
) => {
  const saved = qualityEventRows(value);
  if (!field.sourceRows) return saved;
  const byId = new Map(saved.map((row) => [row.id, row]));
  return field.sourceRows.fieldKeys
    .flatMap((key) => qualityEventRows(sourceAnswers[key]))
    .map((source) => byId.get(source.id) ?? { id: source.id, answers: {} });
};
